module.exports = __webpack_public_path__ + "static/media/TotalPurchasedAmountApplicantPortal.49c1f37c.svg";